import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkspaceHero } from '../components/workspace/WorkspaceHero';
import { WorkspaceTasks } from '../components/workspace/WorkspaceTasks';
import { WorkspaceSurfaces } from '../components/workspace/WorkspaceSurfaces';
import { WorkspaceWorkflow } from '../components/workspace/WorkspaceWorkflow';
import { WorkspaceModules } from '../components/workspace/WorkspaceModules';
import { ClosingInvitation } from '../components/sections/ClosingInvitation';
import { NotFound } from './NotFound';
import { workspaces } from '../data/workspaces';
export function WorkspaceDetail() {
  const {
    slug
  } = useParams();
  const workspace = workspaces.find(w => w.slug === slug);
  if (!workspace) return <NotFound data-id="element-735" data-mp="1ypjexdr8imb1" />;
  return <>
      <WorkspaceHero workspace={workspace} data-id="element-736" data-mp="1b104osomjzgb" />
      <WorkspaceTasks workspace={workspace} data-id="element-737" data-mp="1azyqifcbawud" />
      <WorkspaceSurfaces workspace={workspace} data-id="element-738" data-mp="1626p8ups1ydi" />
      <WorkspaceWorkflow workspace={workspace} data-id="element-739" data-mp="161dsmmkj8p93" />
      <WorkspaceModules workspace={workspace} data-id="element-740" data-mp="30rtr81gr8r7a" />
      <ClosingInvitation title={`Bring Noetivra to your ${workspace.name.toLowerCase()} team.`} body="Tell us about your organization and the workflow you have in mind. We’ll walk through a configuration together." primary={{
      label: 'Start an implementation conversation',
      to: `/contact?workspace=${workspace.slug}`
    }} secondary={{
      label: 'Browse other workspaces',
      to: '/workspaces'
    }} data-id="element-741" data-mp="30r0uzuff9k3e" />
    </>;
}